import { post } from './httpServer';

export default {
  add(comment) {
    return post('/api/user/message/', comment);
  },
};



// WEBPACK FOOTER //
// ./src/service/comment.js